import type { BankAccountType } from '@api';
import type { BankAccountFormSchemaType } from '../../useBankAccountFormSchema';

export const getEditBankAccountDefaultValues = (
  bankAccount: BankAccountType
): BankAccountFormSchemaType => ({
  accountHolderName: bankAccount.accountHolderName,
  accountHolderAddress: {
    street: bankAccount.accountHolderAddress.street ?? '',
    addition: bankAccount.accountHolderAddress.addition ?? '',
    zip: bankAccount.accountHolderAddress.zip ?? '',
    city: bankAccount.accountHolderAddress.city ?? '',
    cityEnglish: bankAccount.accountHolderAddress.cityEnglish ?? '',
    state: bankAccount.accountHolderAddress.state ?? '',
    country: bankAccount.accountHolderAddress.country ?? '',
  },
  currency: bankAccount.currency,
  bankName: bankAccount.bankName,
  bankAddress: {
    street: bankAccount.bankAddress.street ?? '',
    addition: bankAccount.bankAddress.addition ?? '',
    zip: bankAccount.bankAddress.zip ?? '',
    city: bankAccount.bankAddress.city ?? '',
    cityEnglish: bankAccount.bankAddress.cityEnglish ?? '',
    state: bankAccount.bankAddress.state ?? '',
    country: bankAccount.bankAddress.country ?? '',
  },
  accountNumber: bankAccount.accountNumber ?? '',
  bicSwift: bankAccount.bicSwift ?? '',
  iban: bankAccount.iban ?? '',
  routingNumber: bankAccount.routingNumber ?? '',
  notes: bankAccount.notes ?? '',
  creditorNumber: bankAccount.creditorNumber ?? '',
});
